//wrappers/SlowLoad.js
import { useRef } from "react";
import { useInView, motion } from "framer-motion";

export default function SlowLoad({ children }) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.3 })

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: "easeOut" }}
      ref={ref}
    >
      {children}
    </motion.div>
  )
}
